import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash alerts after a timeout.
// Attach to alert elements: data-controller="flash"
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => {
      this.element.classList.remove("show")
      // Remove from DOM after Bootstrap fade animation
      setTimeout(() => this.element.remove(), 150)
    }, 2000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
